"use client";

import { isLandauLive } from "@/lib/consts";
import { useMessages } from "@/lib/i18n/useMessages";
import {
  getTeamMemberSlug,
  getTeamMembersRecord,
  TeamMemberEnum,
} from "@/lib/teamData";
import { Avatar, AvatarGroup, Stack, Tooltip, Typography } from "@mui/material";

export const SLTeamAvatarGroup = () => {
  const messages = useMessages();
  const teamRecord = getTeamMembersRecord(messages.team);
  const moritzSlug = getTeamMemberSlug(TeamMemberEnum.MoritzRiehl);
  const teamMembersList = Object.values(teamRecord).filter((member) =>
    isLandauLive ? true : member.slug !== moritzSlug,
  );

  return (
    <Stack
      direction={{ xs: "column", md: "row" }}
      alignItems="center"
      spacing={1}
      mt={2}
    >
      <AvatarGroup max={3} sx={{ cursor: "pointer" }}>
        {teamMembersList.map((member) => (
          <Tooltip
            key={member.slug}
            title={
              <Typography color="white" variant="body2">
                {[member.fullName, member.role].join(" - ")}
              </Typography>
            }
            arrow={true}
          >
            <Avatar
              alt={member.fullName}
              src={member.image[600] || member.image[1050] || ""}
              sx={{
                width: 60,
                height: 60,
              }}
            >
              {member.fullName.charAt(0)}
            </Avatar>
          </Tooltip>
        ))}
      </AvatarGroup>

      <Typography variant="body2" color="text.secondary">
        {messages.common.teamPreview.caption}
      </Typography>
    </Stack>
  );
};
